var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoolS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40431 2.66817L7.40135 2.66361L7.40193 2.67431L6.71446 2.7065V3.38603H5.25797V2.67402H4.59324L4.59376 2.66361L4.58701 2.67402H4.59324C4.5876 2.78606 4.5821 2.89889 4.57645 3.01466C4.57063 3.13411 4.56465 3.2567 4.55822 3.38481H3.1109V2.67378L3.11888 2.67341L3.11765 2.67191V2.66362H4.58506L4.58579 2.67403L4.59253 2.66362H4.58506L4.5654 2.38383L4.56538 2.38362C4.55661 2.2595 4.54782 2.13505 4.53922 2.00981H3.11765V2.66362H3.11091L3.1109 2.66361V2.66362H3.10969L3.1109 2.66511V2.67378L2.4179 2.70527V3.41789H1V9.83273H11V3.40687H9.57843V2.7065L8.8842 2.67373V2.66571L8.88542 2.66422H8.8842V2.66361L8.88378 2.66422H8.87746V2H7.45405C7.43775 2.2294 7.42264 2.4469 7.40755 2.66422H7.40257L7.40431 2.66817ZM7.40699 2.67231L7.40809 2.67402L7.40193 2.67431C7.4148 2.91215 7.42748 3.14959 7.43996 3.38664H8.8842V2.67373L8.87793 2.67344L8.87746 2.67402L8.87746 2.67341L8.87746 2.66422H7.40755C7.40736 2.66692 7.40717 2.66961 7.40699 2.67231ZM10.2641 9.11949V4.16177H9.59621V7.69425H8.87746L8.86751 7.47582C8.86083 7.32818 8.85424 7.18276 8.84682 7.02819H5.30883L5.29481 7.30607L5.27513 7.69486H4.55086V4.16177H1.72304V9.11949H10.2641ZM8.84682 5.59559H5.31006V6.24755H8.84682V5.59559ZM8.84375 4.16483H5.30638V4.80331H8.84375V4.16483Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolS);
export default __webpack_public_path__ + "static/media/pool-s.bf841658c21903ce4ac0f22a33212636.svg";
export { ForwardRef as ReactComponent };